import React from 'react';
import { GEBAEUDETYP_LABEL, GEBAEUDETYP_WERTE } from '../fragenkatalog';
import { DRITTER_FELDER, gebaeudetypAus, setzeDritterFeld } from '../planungLogic';
import type { DritterNachPara4 } from '../types';
import type { GrundlagenProps } from './typen';

/** Beschriftung der drei Felder des Dritten nach § 4 BaustellV. */
const DRITTER_LABEL: Record<keyof DritterNachPara4, { label: string; platzhalter: string }> = {
    name: { label: 'Name / Firmierung', platzhalter: 'z. B. Muster Projektsteuerung GmbH' },
    anschrift: { label: 'Anschrift', platzhalter: 'Straße, PLZ Ort' },
    rolle: { label: 'Rolle', platzhalter: 'z. B. Generalübernehmer, Projektsteuerer, Bauherrenvertreter' },
};

/** Abschnitt „Nutzung und Zuständigkeit" (keine Trigger): Gebaeudetyp und
 *  Dritter nach § 4 BaustellV. */
export const GrundlagenNutzung: React.FC<GrundlagenProps> = ({
    merkmale, isReadOnly, onMerkmal,
}) => {
    const dritter = merkmale.dritterNachPara4;

    return (
        <section className="bg-white rounded-2xl border border-slate-200 p-5">
            <h3 className="font-bold text-slate-800 mb-1">Nutzung und Zuständigkeit</h3>
            <p className="text-xs text-slate-500 mb-4">
                Angaben für die Folgeunterlagen. Sie blenden keine Fragen aus: der Gebäudetyp wählt die
                Vorlage der Unterlage für spätere Arbeiten, der Dritte nach § 4 BaustellV gehört in die
                Vorankündigung (Punkt 4) und ergänzt die Antwort auf PL-A-02.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div>
                    <span className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1">
                        Gebäudetyp / Nutzung
                    </span>
                    <select
                        value={merkmale.gebaeudetyp || ''}
                        disabled={isReadOnly}
                        onChange={e => onMerkmal('gebaeudetyp', gebaeudetypAus(e.target.value))}
                        className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm disabled:bg-slate-50"
                    >
                        <option value="">(noch nicht geklärt)</option>
                        {GEBAEUDETYP_WERTE.map(g => (
                            <option key={g} value={g}>{GEBAEUDETYP_LABEL[g]}</option>
                        ))}
                    </select>
                    <span className="block text-[11px] text-slate-400 mt-1">
                        Dieselben Vorlagen wie im Generator der Unterlage für spätere Arbeiten
                    </span>
                </div>
                <div className="lg:col-span-2">
                    <span className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1">
                        Dritter nach § 4 BaustellV
                    </span>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                        {DRITTER_FELDER.map(feld => (
                            <label key={feld} className="block">
                                <span className="block text-[11px] text-slate-500 mb-1">{DRITTER_LABEL[feld].label}</span>
                                <input
                                    type="text"
                                    disabled={isReadOnly}
                                    value={(dritter && dritter[feld]) || ''}
                                    onChange={e => onMerkmal('dritterNachPara4', setzeDritterFeld(dritter, feld, e.target.value))}
                                    className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm disabled:bg-slate-50"
                                    placeholder={DRITTER_LABEL[feld].platzhalter}
                                />
                            </label>
                        ))}
                    </div>
                    <span className="block text-[11px] text-slate-400 mt-1">
                        Nur ausfüllen, wenn der Bauherr die Maßnahmen nach § 2 und § 3 Abs. 1 Satz 1 BaustellV
                        übertragen hat. Ob und mit welchem Dokument, klärt PL-A-02. Leer heißt „nichts erfasst",
                        nicht „kein Dritter".
                    </span>
                </div>
            </div>
        </section>
    );
};
